import {useEffect, useState} from "react";
import {
    Drawer,
    Button,
    Header,
    Form,
    useDrawer,
} from "../../design";
import {translate} from "../../utils/translations";
import SubscriptionGroupCard from "../cards/subscription-group";
import SubscriptionOverviewCard from "../cards/subscription-overview";
import MergeSubscriptionDateSelectDrawer from "./merge-subscription-date-select";

function MergeSubscriptionSelectDrawer(props: any) {

    const drawers = useDrawer();
    const [selectedContractIndexesSet, setselectedContractIndexesSet] = useState(new Set([]));

    const toggleSubscriptionSelect = (i: number) => {
        let _newSet = new Set(selectedContractIndexesSet);
        if (selectedContractIndexesSet.has(i)) {
            _newSet.delete(i);
        } else {
            _newSet.add(i);
        }
        setselectedContractIndexesSet(_newSet);
    };

    const toggleDateSelectDrawer = () => {
        drawers.open({
            component: MergeSubscriptionDateSelectDrawer,
            props: {
                selectedContracts: props.selectedGroup.contracts.filter((_item: any, i: number) => selectedContractIndexesSet.has(i)),
                reloadContracts: props.reloadContracts
            }
        })
    }

    const getEligibleContracts = () => {
        const contracts = props.selectedGroup.contracts;
        const nonDigitalSubscriptions = contracts.map((c: any, i: number) => ({c ,i}))
        .filter(({c}) => !c.isDigitalSubscription);

        const max_cycle = nonDigitalSubscriptions[0].c.billing_policy.max_cycles;
        const min_cycle = nonDigitalSubscriptions[0].c.billing_policy.min_cycles;

        const eligibleContracts = nonDigitalSubscriptions.filter(({c}) =>
            c.billing_policy.max_cycles === max_cycle &&
            c.billing_policy.min_cycles === min_cycle
        );
        return eligibleContracts;
    }

    return (
        <Drawer id="merge-subscriptions-select-contracts" title={translate('merge_subscriptions_drawer_title')}
                active={props.active} toggleActive={props.toggleActive}>
            <Drawer.Body>
                <SubscriptionGroupCard group={props.selectedGroup}/>
                <Header.H3 className="my-3">{translate('merge_subscription_subscriptions_to_merge_label')}</Header.H3>

                {getEligibleContracts().map(({c, i}) => (
                              <Form.Checkbox key={i} className="my-3"
                                   onChange={() => toggleSubscriptionSelect(i)}
                                   checked={selectedContractIndexesSet.has(i)}
                                   id={`subscription-select-${i}`}
                                   label={<SubscriptionOverviewCard contract={c} onClick={() => toggleSubscriptionSelect(i)}/>}
                    />
                    ))}

            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button size="lg" className="m-2" disabled={selectedContractIndexesSet.size < 2}
                            onClick={toggleDateSelectDrawer}>{translate('merge_subscription_choose_order_date_button')}</Button>
                    <Button size="lg" variant="underline" className="m-2"
                            onClick={props.toggleActive}>{translate('go_back_button')}</Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}

export default MergeSubscriptionSelectDrawer;
